import { config } from "@/config/env";

const FOOTER_LINKS = [
  { label: "Privacy", href: "https://aboutgolf.com/privacy" },
  { label: "Support", href: "https://www.aboutgolf.com/support" },
  {
    label: "Knowledgebase",
    href: "https://aboutgolf.my.site.com/Knowledgebase/s/",
  },
];

const Footer: React.FC = () => {
  const buildVersion = config.buildVersion;
  const isDev = process.env.NODE_ENV !== "production";

  return (
    <footer className="w-full border-t border-border mt-12 px-6 py-1 pt-4">
      <div className="flex flex-wrap items-center justify-between gap-y-2 text-[11px] text-text-muted mulish">
        <span>
          &copy; {new Date().getFullYear()}{" "}
          <a
            href="https://aboutgolf.com"
            target="_blank"
            rel="noreferrer"
            className="hover:text-text-primary transition-colors"
          >
            aboutGOLF
          </a>
          . All rights reserved.
          {isDev && (
            <span className="ml-3 text-text-muted/50 font-mono text-[10px]">
              v{buildVersion}
            </span>
          )}
        </span>
        <div className="flex items-center gap-x-4">
          {FOOTER_LINKS.map(({ label, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noreferrer"
              className="hover:text-text-primary transition-colors"
            >
              {label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
